import { BUSINESS } from "../../../mocks/siteData";

export default function TrustBar() {
  const signals = [
    { icon: "ri-award-line", label: "Voted Utah's Best Lashes", sub: "Utah Valley Magazine" },
    { icon: "ri-star-fill", label: `${BUSINESS.googleRating} Stars`, sub: `${BUSINESS.reviewCount} Verified Google Reviews` },
    { icon: "ri-verified-badge-line", label: "Certified Lash Artists", sub: "VIP & Diamond Tier Trained" },
    { icon: "ri-heart-3-line", label: "Gives Back Globally", sub: "Humanitarian Missions Worldwide" },
    { icon: "ri-shield-check-line", label: "Licensed & Insured", sub: "Utah State Certified Studio" },
  ];

  return (
    <section className="bg-charcoal-dark border-b border-white/5 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-0">
        <div className="flex flex-col md:flex-row divide-y md:divide-y-0 md:divide-x divide-white/8">
          {signals.map((s, i) => (
            <div
              key={i}
              className="flex flex-row md:flex-col items-center md:items-center gap-3 md:gap-2 py-4 md:py-6 px-0 md:px-6 flex-1 md:text-center"
            >
              <div className="w-8 h-8 flex items-center justify-center text-gold flex-shrink-0">
                <i className={`${s.icon} text-base`} />
              </div>
              <div>
                <div className="font-sans text-xs text-white font-medium whitespace-nowrap">
                  {s.label}
                </div>
                <div className="font-sans text-[10px] text-white/35 whitespace-nowrap mt-0.5">
                  {s.sub}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
